import { Component, ElementRef, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MetaDefinition } from '@angular/platform-browser';
import { ToastrManager } from 'ng6-toastr-notifications';
import { first } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { User } from 'src/app/model/user.model';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { SeoService } from 'src/app/service/seo.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';



@Component({
  selector: 'app-landingpages',
  templateUrl: './landingpages.component.html',
  styleUrls: ['./landingpages.component.scss'],
  

})
export class LandingpagesComponent implements OnInit {

  rfqloader: boolean;
  activerfqall: any;
  offset: any;
  closeDate: Date;
  closeMonth: number;
  message: any = "";
  currentUser: User;
  myemail: any;
  hostName = GlobalComponent.hostName;
  title = "Get Your Vendor -Best B2B Manufacturing Facility Search Portal - Home";
  metaTags=[
    { name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace connects vendors and buyers towards facilitating manufacturing multiple categories, which would streamline into global sourcing and custom manufacturing.'},
    { name:'robots', content:'index, follow'},
    {name:'keywords',content:'custom-manufacturing,component'},
  ];

  constructor(  private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    public toastr: ToastrManager,private SEOService:SeoService,public elementRef: ElementRef<HTMLElement>,private router:Router) {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
     }
    
  ngOnInit() {
    window.scroll(0,0);   

     this.SEOService.updateCanonicalUrl(this.hostName);
     this.SEOService.updateTitle(this.title);
     this.SEOService.updateMetaTags(this.metaTags);

     document.getElementById('fab').style.display = "none";
     document.getElementById('cast').style.display = "none";
     document.getElementById('forge').style.display = "none";
     document.getElementById('press').style.display = "none";
     
     
     document.getElementById('machdesc').style.display="block";
     document.getElementById('castdesc').style.display="none";
     document.getElementById('fabdesc').style.display="none";
     document.getElementById('forgedesc').style.display="none";
     document.getElementById('pressdesc').style.display="none";

    
     // Set the date we're counting down to
    //  var countDownDate = new Date("May 29, 2024 17:00:00").getTime();
     
    //  // Update the count down every 1 second
    //  var x = setInterval(function() {
     
    //    // Get today's date and time
    //    var now = new Date().getTime();
     
    //    // Find the distance between now and the count down date
    //    var distance = countDownDate - now;
     
    //    // Time calculations for days, hours, minutes and seconds
    //    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    //    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    //    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    //    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
     
    //    // Display the result in the element with id="demo"
    //    document.getElementById("demo").innerHTML = days + "d " + hours + "h "
    //    + minutes + "m " + seconds + "s ";
     
    //    // If the count down is finished, write some text
    //    if (distance < 0) {
    //      clearInterval(x);
    //      document.getElementById("demo").innerHTML = "EXPIRED";
    //    }
    //  }, 1000);
     
  }

  showImage() {
    /* Access image by id and change 
    the display property to block*/
    document.getElementById('image').style.display = "block";
    document.getElementById('btnID').style.display = "none";
} 

showfabImage()
{
  document.getElementById('fab').style.display = "block";
  document.getElementById('fabtnid').style.backgroundColor= "#173150";
  document.getElementById('fabtnid').style.color= "white";

  document.getElementById('machine').style.display = "none";
  document.getElementById('macbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('macbtnid').style.color= "black";

  document.getElementById('cast').style.display = "none";
  document.getElementById('castbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('castbtnid').style.color= "black";
  
  document.getElementById('forge').style.display = "none";
  document.getElementById('forgebtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('forgebtnid').style.color= "black";


  document.getElementById('press').style.display = "none";
  document.getElementById('pressbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('pressbtnid').style.color= "black";

  
  document.getElementById('castdesc').style.display="none";
  document.getElementById('forgedesc').style.display="none";
  document.getElementById('pressdesc').style.display="none";
  document.getElementById('machdesc').style.display="none";
  document.getElementById('fabdesc').style.display="block";


}

showMachImage(){
  document.getElementById('machine').style.display = "block";
  document.getElementById('macbtnid').style.backgroundColor= "#173150";
  document.getElementById('macbtnid').style.color= "white";

  document.getElementById('fab').style.display = "none";
  document.getElementById('fabtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('fabtnid').style.color= "black";

  document.getElementById('cast').style.display = "none";
  document.getElementById('castbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('castbtnid').style.color= "black";

  document.getElementById('forge').style.display = "none";
  document.getElementById('forgebtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('forgebtnid').style.color= "black";

  document.getElementById('press').style.display = "none";
  document.getElementById('pressbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('pressbtnid').style.color= "black";
  
  document.getElementById('fabdesc').style.display="none";
  document.getElementById('castdesc').style.display="none";
  document.getElementById('forgedesc').style.display="none";
  document.getElementById('pressdesc').style.display="none";
  document.getElementById('machdesc').style.display= "block";


}

showCastImage(){
  document.getElementById('cast').style.display = "block";
  document.getElementById('castbtnid').style.backgroundColor= "#173150";
  document.getElementById('castbtnid').style.color= "white";
  document.getElementById('castdesc').style.display="block";

  document.getElementById('fab').style.display = "none";
  document.getElementById('fabtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('fabtnid').style.color= "black";

  document.getElementById('machine').style.display = "none";
  document.getElementById('macbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('macbtnid').style.color= "black";
    
  document.getElementById('forge').style.display = "none";
  document.getElementById('forgebtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('forgebtnid').style.color= "black";

  document.getElementById('press').style.display = "none";
  document.getElementById('pressbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('pressbtnid').style.color= "black";

  document.getElementById('machdesc').style.display="none";
  document.getElementById('fabdesc').style.display="none";
  document.getElementById('forgedesc').style.display="none";
  document.getElementById('pressdesc').style.display="none";
  document.getElementById('castdesc').style.display="block";

}

showforgImage(){
  document.getElementById('forge').style.display = "block";
  document.getElementById('forgebtnid').style.backgroundColor= "#173150";
  document.getElementById('forgebtnid').style.color= "white";

  document.getElementById('fab').style.display = "none";
  document.getElementById('fabtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('fabtnid').style.color= "black";

  document.getElementById('machine').style.display = "none";
  document.getElementById('macbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('macbtnid').style.color= "black";
    
  document.getElementById('cast').style.display = "none";
  document.getElementById('castbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('castbtnid').style.color= "black";

  document.getElementById('press').style.display = "none";
  document.getElementById('pressbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('pressbtnid').style.color= "black";

  document.getElementById('fabdesc').style.display="none";
  document.getElementById('castdesc').style.display="none";
  document.getElementById('pressdesc').style.display="none";
  document.getElementById('machdesc').style.display="none";
  document.getElementById('forgedesc').style.display="block";

}

showpressImage()
{
  
  document.getElementById('press').style.display = "block";
  document.getElementById('pressbtnid').style.backgroundColor= "#173150";
  document.getElementById('pressbtnid').style.color= "white";
  
  document.getElementById('forge').style.display = "none";
  document.getElementById('forgebtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('forgebtnid').style.color= "black";

  document.getElementById('fab').style.display = "none";
  document.getElementById('fabtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('fabtnid').style.color= "black";

  document.getElementById('machine').style.display = "none";
  document.getElementById('macbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('macbtnid').style.color= "black";
    
  document.getElementById('cast').style.display = "none";
  document.getElementById('castbtnid').style.backgroundColor= "#D9D9D9";
  document.getElementById('castbtnid').style.color= "black";

  document.getElementById('fabdesc').style.display="none";
  document.getElementById('castdesc').style.display="none";
  document.getElementById('forgedesc').style.display="none";
  document.getElementById('machdesc').style.display="none";
  document.getElementById('pressdesc').style.display="block";

  



}

signup()
  {
    this.router.navigate(['/login/signup']);

  }



  openDialog(): void {
    this.dialog.open(DemoComponent, {
      width: '500px',
      
    }  
    
    );

  
  }


  

}


@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./landingpages.component.scss']
  
})
export class DemoComponent implements OnInit {
  leadForm: UntypedFormGroup;
  submitted = false;

  constructor(public dialogRef: MatDialogRef<DemoComponent>,
    private formBuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    public toastr: ToastrManager) {}

    ngOnInit() {
        this.leadForm = this.formBuilder.group({
            company_name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', [Validators.required, Validators.minLength(10), Validators.pattern("^[0-9]*$")]],
        });
    }
  
    // convenience getter for easy access to form fields
    get f() { return this.leadForm.controls; }
  
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.leadForm.invalid) {
            return;
        }
  
        //console.log(this.f.email.value);
          this.authenticationService.create_lead(this.f.company_name.value, this.f.email.value, this.f.phone.value, 0)
              .pipe(first())
              .subscribe(
                  data => {
                    //console.log(data);
                    this.toastr.successToastr("Thank You!", 'Our Team will call you within 24 hours!');
                  },
                  error => {
                  });
    
        this.dialogRef.close();
         
    }
}

